import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useNavigate } from 'react-router-dom';

const SubscriptionActivation = ({ plan, billingCycle }) => {
  const navigate = useNavigate();

  const premiumFeatures = [
    {
      icon: 'Briefcase',
      title: 'Unlimited Job Postings',
      description: 'Post as many jobs as you need',
      path: '/job-posting'
    },
    {
      icon: 'Users',
      title: 'Enhanced Candidate Access',
      description: 'View unlimited candidate profiles',
      path: '/candidate-management'
    },
    {
      icon: 'BarChart3',
      title: 'Advanced Analytics',
      description: 'Access detailed hiring insights',
      path: '/analytics-reporting-dashboard'
    },
    {
      icon: 'Calendar',
      title: 'Interview Scheduling',
      description: 'Automated interview management',
      path: '/interview-scheduling-management'
    }
  ];

  return (
    <div className="bg-card rounded-xl border border-border p-6 shadow-warm-sm">
      <div className="flex items-center gap-2 mb-6">
        <Icon name="Sparkles" size={20} className="text-accent" />
        <h2 className="text-lg font-heading font-bold text-foreground">
          Subscription Activated
        </h2>
      </div>
      {/* Activation Status */}
      <div className="bg-gradient-to-br from-success/10 to-primary/5 rounded-lg p-6 mb-6 border border-success/20">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0">
            <div className="w-12 h-12 bg-success rounded-full flex items-center justify-center">
              <Icon name="Check" size={24} className="text-white" />
            </div>
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-heading font-bold text-foreground mb-2">
              Welcome to {plan?.name} Plan!
            </h3>
            <p className="text-sm text-muted-foreground mb-3">
              Your subscription is now active and all premium features are unlocked.
            </p>
            <div className="flex items-center gap-2 text-sm text-foreground">
              <Icon name="Calendar" size={16} className="text-accent" />
              <span>
                Active until {billingCycle === 'monthly' ? new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)?.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
                  : new Date(Date.now() + 365 * 24 * 60 * 60 * 1000)?.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* Unlocked Features */}
      <div className="mb-6">
        <h3 className="text-sm font-semibold text-foreground mb-4">Newly Unlocked Features</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {premiumFeatures?.map((feature, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-primary/5 to-accent/5 rounded-lg p-4 border border-border hover:border-primary/50 transition-all cursor-pointer group"
              onClick={() => navigate(feature?.path)}
            >
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0">
                  <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center group-hover:bg-primary/20 transition-colors">
                    <Icon name={feature?.icon} size={20} className="text-primary" />
                  </div>
                </div>
                <div className="flex-1">
                  <p className="font-medium text-foreground text-sm mb-1">{feature?.title}</p>
                  <p className="text-xs text-muted-foreground">{feature?.description}</p>
                </div>
                <Icon name="ArrowRight" size={16} className="text-muted-foreground group-hover:text-primary transition-colors" />
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Quick Actions */}
      <div className="bg-muted/30 rounded-lg p-4">
        <p className="text-sm font-medium text-foreground mb-3">Quick Actions</p>
        <div className="flex flex-col sm:flex-row gap-3">
          <Button
            variant="outline"
            size="default"
            iconName="Briefcase"
            onClick={() => navigate('/job-posting')}
            className="flex-1"
          >
            Post Your First Job
          </Button>
          <Button
            variant="outline"
            size="default"
            iconName="Users"
            onClick={() => navigate('/candidate-management')}
            className="flex-1"
          >
            Browse Candidates
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionActivation;